import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import "./profile.scss";
import Footer from "../../components/footer/footer";
import Header from "../../components/header/header";
import Image from "../../components/image/image";
import NextIcon from "../../assets/backIcon.svg";
// import RewardIcon from "../../assets/reward.svg";
import HistoryIcon from "../../assets/OrderHistory.png";
import RatingIcon from "../../assets/rating.svg";
import HelpIcon from "../../assets/Help.png";

const Profile = () => {
  const navigate = useNavigate();
  const walletReward = useSelector((state) => state.wallet.coins);

  const handleBack = () => {
    navigate("/outlet-list");
  };

  const handleHelp = () => {
    navigate("/help");
  };

  const handleHistory = () => {
    navigate("/order-history");
  };

  const handleRating = () => {
    navigate("/rating-review");
  };

  return (
    <>
      <div className="profile-page">
        <Header 
          coin={walletReward}
          onClick={handleBack} 
          label="Profile"           
          exitButton={true}
        />
        <div className="profile-options">
          {/* <div className="option">
            <Image
              src={RewardIcon}
              className="profile-option-icons"
              alt="reward icon"
            />
            <span>My Rewards</span>
            <Image
              src={NextIcon}
              className="profile-option-icons"
              alt="arrow icon"
            />
          </div> */}
          <div className="option" onClick={handleHistory}>
            <img src={HistoryIcon} className="profile-option-icons" alt="reward" />
            <span>Order History</span>
            <img src={NextIcon} className="arrow-icon" alt="arrow icon" />
          </div>
          {/* <div className="option" onClick={handleRating}>
            <Image
              src={RatingIcon}
              className="profile-option-icons"
              alt="reward icon"
            />
            <span>Rating and Reviews</span>
            <img src={NextIcon} className="arrow-icon" alt="arrow icon" />
          </div> */}
          <div className="help" onClick={handleHelp}>
            <img src={HelpIcon} className="profile-option-icons" alt="help" />
            <span>Help</span>
            <img src={NextIcon} className="arrow-icon" alt="arrow icon" />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Profile;
